import React, { Component } from "react";

import {
  Row,
  Wrapper,
  Copy,
  Icon,
  Spin,
  ProfilePic
} from "app/NativeComponents/common";

import { renderDate } from "app/NativeActions";
class MessageNote extends Component {
  renderSubTitle() {
    const {
      failed_to_send,
      sending_message,
      from_phone_number,
      date_created,
      colors
    } = this.props;

    if (failed_to_send) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginTop: 0,
            marginBottom: 0,
            alignItems: "flex-end"
          }}
        >
          <Row>
            <Icon size={14} icon="error" />
            <Copy
              style={{
                color: colors.light_text_color,
                fontSize: 10,
                marginLeft: 5
              }}
            >
              Failed To Send
            </Copy>
          </Row>
        </Wrapper>
      );
    }

    if (sending_message) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginTop: 0,
            marginBottom: 0,
            alignItems: "flex-end"
          }}
        >
          <Row>
            <Copy
              style={{
                color: colors.light_text_color,
                fontSize: 10,
                marginLeft: 5
              }}
            >
              Posting...
            </Copy>
          </Row>
        </Wrapper>
      );
    }
    return (
      <Wrapper
        style={{
          margin: 10,
          marginTop: 0,
          marginBottom: 0,
          alignItems: "flex-end"
        }}
      >
        <Copy style={{ color: colors.light_text_color, fontSize: 10 }}>
          {renderDate(date_created, false, "time")}
        </Copy>
      </Wrapper>
    );
  }

  renderLoading() {
    if (this.props.sending_message) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginLeft: 0,
            marginBottom: 20,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Spin size={"small"} />
        </Wrapper>
      );
    }
  }

  renderImage() {
    if (!this.props.sending_message && this.props.user) {
      return (
        <ProfilePic
          size={26}
          email={this.props.user.email}
          image={this.props.user.image}
          style={{ margin: 10, marginLeft: 0, marginBottom: 20 }}
        />
      );
    }
  }

  render() {
    const { colors, message_text } = this.props;
    return (
      <Wrapper>
        <Row style={{ justifyContent: "flex-end" }}>
          <Wrapper>
            <Wrapper
              style={{
                margin: 10,
                marginBottom: 5,
                marginLeft: 40,
                padding: 15,
                backgroundColor: colors.yellow_card_color_muted,
                borderRadius: 5
              }}
            >
              <Copy>{message_text}</Copy>
            </Wrapper>
            {this.renderSubTitle()}
          </Wrapper>
          {this.renderImage()}
          {this.renderLoading()}
        </Row>
      </Wrapper>
    );
  }
}

export default MessageNote;
